module.exports = __webpack_public_path__ + "static/media/piano.f522542f.mp3";